/** Tema salvo no Redux/localStorage: claro, escuro ou Questor (base escura + fundo alaranjado + itens estilo claro). */

export const THEME_KEYS = {
	LIGHT: "light",
	DARK: "dark",
	QUESTOR: "questor",
};

export function isValidStoredTheme(value) {
	return (
		value === THEME_KEYS.LIGHT ||
		value === THEME_KEYS.DARK ||
		value === THEME_KEYS.QUESTOR
	);
}

/** Arquivo CSS carregado pelo react-css-theme-switcher (só existe light/dark). */
export function getCssSwitcherKey(theme) {
	if (theme === THEME_KEYS.DARK || theme === THEME_KEYS.QUESTOR) {
		return THEME_KEYS.DARK;
	}
	return THEME_KEYS.LIGHT;
}

/** Shell escuro (header Ant dark, menu antTheme dark). */
export function isDarkShell(theme) {
	return theme === THEME_KEYS.DARK || theme === THEME_KEYS.QUESTOR;
}

/** Página login Figma: fundo claro só no modo Claro. */
export function isLightLoginPage(theme) {
	return theme === THEME_KEYS.LIGHT;
}
